export default "__VITE_ASSET__6v7fa$N9__"